/**
 * Get files from groups by ids
 * @param {*} items
 * @param {string[]} ids
 * @returns {*[]}
 */
export default function getFilesByIds(items, ids) {
  return Object.values(items).reduce((result, group) => [...result, ...group.filter(({ id }) => ids.includes(id))], []);
}
